window.addEventListener('DOMContentLoaded', (event) => {
  const stickyElement = document.querySelector('.atc-sticky-container');
  const mainAddToCartBtn = document.querySelector('[data-main-product="true"]');
  const img = stickyElement?.querySelector('.atc-product-content img');
  const selectField = stickyElement?.querySelector('select[name="id"]');
  const plusButton = stickyElement?.querySelector('button[name="plus"]');
  const minusButton = stickyElement?.querySelector('button[name="minus"]');
  const quantityInput = stickyElement?.querySelector('.quantity__input');

  let hasScrolledPastButton = false;
  let mainButtonIsVisible = true;

  // Set initial padding and hide sticky container
  if (stickyElement) {
    document.documentElement.style.paddingBottom = `${stickyElement.clientHeight}px`;
    stickyElement.setAttribute('aria-hidden', 'true');
  }

  function updateStickyVisibility() {
    if (!stickyElement || !mainAddToCartBtn) return;

    const buttonRect = mainAddToCartBtn.getBoundingClientRect();
    const buttonPosition = buttonRect.top + window.scrollY;
    hasScrolledPastButton = window.scrollY > buttonPosition;

    // Only show sticky when scrolled past AND main button is not visible
    stickyElement.setAttribute('aria-hidden', mainButtonIsVisible || !hasScrolledPastButton);
  }

  // Create Intersection Observer for the main add to cart button
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (stickyElement) {
        mainButtonIsVisible = entry.isIntersecting;
        updateStickyVisibility();
      }
    });
  }, {
    threshold: 0,
    rootMargin: '0px'
  });

  // Start observing main add to cart button
  if (mainAddToCartBtn) {
    observer.observe(mainAddToCartBtn);
  }

  // Add scroll event listener
  window.addEventListener('scroll', updateStickyVisibility);

  // Run initial check
  updateStickyVisibility();

  if (selectField) {
    selectField.addEventListener('change', () => {
      const selectedOption = selectField.options[selectField.selectedIndex];
      if (img) {
        img.setAttribute('src', selectedOption.dataset.img);
      }

      const priceContainer = stickyElement.querySelector('.atc-price-display');
      const currentPrice = priceContainer.querySelector('.price__current');
      const originalPrice = priceContainer.querySelector('.price__original');

      if (currentPrice) {
        currentPrice.textContent = selectedOption.dataset.price;
      }

      if (selectedOption.dataset.comparePrice) {
        if (!originalPrice) {
          const newOriginalPrice = document.createElement('s');
          newOriginalPrice.className = 'price__original';
          priceContainer.insertBefore(newOriginalPrice, currentPrice);
        }
        priceContainer.querySelector('.price__original').textContent = selectedOption.dataset.comparePrice;
      } else if (originalPrice) {
        originalPrice.remove();
      }

      const submitButton = stickyElement.querySelector('.product-form__submit');
      if (submitButton) {
        submitButton.querySelector('span').textContent = 'ADD TO CART';
      }
    });
  }

  if (plusButton && quantityInput) {
    plusButton.addEventListener('click', () => {
      const currentValue = parseInt(quantityInput.value) || 1;
      quantityInput.value = currentValue + 1;
    });
  }

  if (minusButton && quantityInput) {
    minusButton.addEventListener('click', () => {
      const currentValue = parseInt(quantityInput.value) || 1;
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    });
  }

  document.querySelector('.product-form [name="id"]')?.addEventListener('change', (e) => {
    const value = Number(e.target.value);
    if (value && selectField) {
      selectField.value = value;
      selectField.dispatchEvent(new Event('change'));
    }
  });
});